
export const getJsonDataFromDataAttribute = (element: Element, dataAttributeKey: string) => {
    const fullyQualifiedDataAttributeKey = 'data-' + dataAttributeKey;

    const data = element.getAttribute(fullyQualifiedDataAttributeKey) ?? '[]';
    const cleanedData = data.replace(/&nbsp;/g, ' ');

    return JSON.parse(cleanedData);
};

export function getPrimitiveValueFromDataAttribute(element: Element, dataAttributeKey: string) {
    const fullyQualifiedDataAttributeKey = 'data-' + dataAttributeKey;
    return element.getAttribute(fullyQualifiedDataAttributeKey) ?? '';
}
